function searchCriteria(filters) {
  let searchString = '';
  const keys = Object.keys(filters);
  // eslint-disable-next-line array-callback-return
  keys.map(filterName => {
    if (filters[filterName].id && filterName !== 'onlineFirst') {
      if (searchString === '') {
        searchString += `${filterName}:${filters[filterName].id}`;
      } else {
        searchString += `;${filterName}:${filters[filterName].id}`;
      }
    }
  });
  return searchString;
}

function getFiltersState(state) {
  return {
    selectedFilters: state.filters.selectedFilters,
    appliedFilters: state.filters.appliedFilters,
    searchCriteria: searchCriteria(state.filters.appliedFilters),
    filtersModalVisibility: state.filters.filtersModalVisibility,
    filterOnlineFirst: state.filters.appliedFilters.onlineFirst
  };
}

export { getFiltersState };
